import request from '@/utils/request'

export const getCustomer = name =>
  request.get(`/customer-api/customer/list/${name}`)

export const getChild = parentId =>
  request.post('/workflow-api/credit-allocation/overview', parentId)
